module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion"
  }, [_c('h4', {
    staticClass: "title",
    on: {
      "click": function($event) {
        return _vm.handleClick()
      }
    }
  }, [(_vm.active) ? _c('i', {
    staticClass: "icon yule-icon-chevron-down"
  }) : _c('i', {
    staticClass: "icon yule-icon-chevron-right"
  }), _vm._v("\n    " + _vm._s(_vm.$t(_vm.title)) + "\n  ")]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4620841a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Accordion.vue
// module id = 1889
// module chunks = 0